/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import {
  Container,
  Spinner,
  Tab,
  Tabs,
  Modal,
  Table,
  Dropdown,
  Col,
  Nav,
  Row,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import useSubmittedCandidatesAssessments from "./useSubmittedCandidatesAssessments";
import { dateFormatter } from "../../../_helpers/dateFormatter";
import AssignedCandidates from "./AssignedCandidates";
import SuggestedCandidates from "./SuggestedCandidates";
import ShortlistedCandidates from "./ShortlistedCandidates";
import { Loader } from "react-bootstrap-typeahead";
import MainLayout from "../../Common/MainLayout";
export default (props) => {
  const {
    loading,
    assignedloading,
    submittedCandidatesInterviewList,
    interviewKit,
    interviewKitSkills,
    nextPage,
    shortlistCandidates,
    remark,
    shortlistIdLoading,
    allBucketList,
    bucketListModal,
    isBucketListLoading,
    isAddToBucketLoading,
    addToBucketItem,
    countQuestions,
    onClickAddAssementToBucket,
    checkExitingAssessment,
    handleCloseBucketModal,
    countCompletedCandidates,
    onViewAssessmentClick,
    editAssessmentKit,
    onPublicProfileClick,
    onShareAssessmentClick,
    onNextPageClick,
    onClickShortlist,
    onClickUnShortlist,
    ontabSelection,
  } = useSubmittedCandidatesAssessments(props);

  return (
    <MainLayout pageName={"Assigned Candidates"}>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <div className="top pb-2">
            {/* <div className="new-listing-section">
              <Container>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <div className="border rounded-lg">
                    <div className="d-flex p-3">
                      <Nav variant="pills" className="listing-top-nav">
                        <Nav.Item>
                          <Nav.Link eventKey="first">Tab 1</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">Tab 2</Nav.Link>
                        </Nav.Item>
                      </Nav>

                      <div className="custom-search-box ml-auto">
                        <div className="search-box-with-icon">
                          <span className="icon">
                            <img
                              src="/assets/images/search-lg-icon.svg"
                              alt="search"
                            />
                          </span>
                          <input type="text" placeholder="Search" />
                        </div>
                        <button>
                          <img
                            src="/assets/images/filter-lines.svg"
                            alt="filter"
                          />
                          Filters
                        </button>
                      </div>
                    </div>
                    <Tab.Content>
                      <Tab.Pane eventKey="first">
                        <div>
                          <Table
                            responsive="lg"
                            className="custom-table mentor-table"
                          >
                            <thead>
                              <tr>
                                <th>Candidate Name</th>
                                <th>Status</th>
                                <th>Skills</th>
                                <th>Last assessed</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <button className="border-0 bg-transparent">
                                      <img
                                        src="/assets/images/star-grey.svg"
                                        alt="star"
                                      />
                                    </button>
                                    <div className="d-flex candidate-info">
                                      <div className="candiate-img">
                                        <img
                                          src="/assets/images/user-img.png"
                                          alt="candidate"
                                        />
                                      </div>
                                      <div className="candiate-content">
                                        <p className="font-weight-bold text-black mb-1">
                                          Mukesh Singh
                                        </p>
                                        <p className="mb-0">mukesh@gmail.com</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <span className="custom-tag rounded-pill px-3 tag-applied">
                                    Applied
                                  </span>
                                </td>
                                <td>
                                  <ul className="skill-list">
                                    <li>Figma</li>
                                    <li>Adobe</li>
                                    <li>Html</li>
                                    <li>Figma</li>
                                    <li>Adobe</li>
                                    <li>Html</li>
                                  </ul>
                                </td>
                                <td>22 Jan 2022</td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <button className="action-btn mr-2">
                                      Assign
                                    </button>

                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant=""
                                        className="no-dropdown-arrow"
                                      >
                                        <img
                                          src="/assets/images/ellipse-v.svg"
                                          alt="options"
                                        />
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item href="#">
                                          Action One
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Action Two
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Action Three
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <button className="border-0 bg-transparent">
                                      <img
                                        src="/assets/images/star-grey.svg"
                                        alt="star"
                                      />
                                    </button>
                                    <div className="d-flex candidate-info">
                                      <div className="candiate-img">
                                        <img
                                          src="/assets/images/user-img.png"
                                          alt="candidate"
                                        />
                                      </div>
                                      <div className="candiate-content">
                                        <p className="font-weight-bold text-black mb-1">
                                          Mukesh Singh
                                        </p>
                                        <p className="mb-0">mukesh@gmail.com</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {" "}
                                  <span className="custom-tag rounded-pill px-3 tag-interview">
                                    interview
                                  </span>
                                </td>
                                <td>
                                  <ul className="skill-list">
                                    <li>Figma</li>
                                    <li>Adobe</li>
                                    <li>Html</li>
                                    <li>Figma</li>
                                    <li>Adobe</li>
                                    <li>Html</li>
                                  </ul>
                                </td>
                                <td>22 Jan 2022</td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <button className="action-btn mr-2">
                                      Assign
                                    </button>

                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant=""
                                        className="no-dropdown-arrow"
                                      >
                                        <img
                                          src="/assets/images/ellipse-v.svg"
                                          alt="options"
                                        />
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item href="#">
                                          Action One
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Action Two
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Action Three
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <button className="border-0 bg-transparent">
                                      <img
                                        src="/assets/images/star-grey.svg"
                                        alt="star"
                                      />
                                    </button>
                                    <div className="d-flex candidate-info">
                                      <div className="candiate-img">
                                        <img
                                          src="/assets/images/user-img.png"
                                          alt="candidate"
                                        />
                                      </div>
                                      <div className="candiate-content">
                                        <p className="font-weight-bold text-black mb-1">
                                          Mukesh Singh
                                        </p>
                                        <p className="mb-0">mukesh@gmail.com</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {" "}
                                  <span className="custom-tag rounded-pill px-3 tag-rejected">
                                    rejected
                                  </span>
                                </td>
                                <td>
                                  <ul className="skill-list">
                                    <li>Figma</li>
                                    <li>Adobe</li>
                                    <li>Html</li>
                                    <li>Figma</li>
                                    <li>Adobe</li>
                                    <li>Html</li>
                                  </ul>
                                </td>
                                <td>22 Jan 2022</td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <button className="action-btn mr-2">
                                      Assign
                                    </button>

                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant=""
                                        className="no-dropdown-arrow"
                                      >
                                        <img
                                          src="/assets/images/ellipse-v.svg"
                                          alt="options"
                                        />
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item href="#">
                                          Action One
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Action Two
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Action Three
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <button className="border-0 bg-transparent">
                                      <img
                                        src="/assets/images/star-grey.svg"
                                        alt="star"
                                      />
                                    </button>
                                    <div className="d-flex candidate-info">
                                      <div className="candiate-img">
                                        <img
                                          src="/assets/images/user-img.png"
                                          alt="candidate"
                                        />
                                      </div>
                                      <div className="candiate-content">
                                        <p className="font-weight-bold text-black mb-1">
                                          Mukesh Singh
                                        </p>
                                        <p className="mb-0">mukesh@gmail.com</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {" "}
                                  <span className="custom-tag rounded-pill px-3 tag-offer">
                                    offer
                                  </span>
                                </td>
                                <td>
                                  <ul className="skill-list">
                                    <li>Figma</li>
                                    <li>Adobe</li>
                                    <li>Html</li>
                                    <li>Figma</li>
                                    <li>Adobe</li>
                                    <li>Html</li>
                                  </ul>
                                </td>
                                <td>22 Jan 2022</td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <button className="action-btn mr-2">
                                      Assign
                                    </button>

                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant=""
                                        className="no-dropdown-arrow"
                                      >
                                        <img
                                          src="/assets/images/ellipse-v.svg"
                                          alt="options"
                                        />
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item href="#">
                                          Action One
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Action Two
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Action Three
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                          <div className="d-flex p-3 border-top">
                            <span>Page 1 of 10</span>
                            <div className="d-flex ml-auto">
                              <button className="bg-transparent py-2 border rounded-lg shadow-sm px-3 font-weight-semi ">
                                Previous
                              </button>
                              <button className="bg-transparent rounded-lg ml-2 py-2 border shadow-sm px-3 font-weight-semi ">
                                Next
                              </button>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">Singh</Tab.Pane>
                    </Tab.Content>
                  </div>
                </Tab.Container>
              </Container>
            </div> */}

            <Container>
              <div className="rounded-lg border bg-white p-3">
                <div className="d-flex justify-content-between mb-2">
                  <h2 className="d-inline-block text-capitalize mr-3 ">
                    {interviewKit?.title}
                  </h2>

                  <div className="d-flex">
                    <button
                      className="bg-transparent border-0 py-2 text-dark"
                      onClick={() => editAssessmentKit(interviewKit?.id)}
                      title="Edit"
                    >
                      <img src="/assets/images/edit-grey.svg" alt="edit" />
                    </button>
                  </div>
                </div>

                <div>
                  <span className="mt-2 mr-4 font-weight-medium">
                    <span className="text-grey-4 font-weight-normal">
                      {" "}
                      Total Topics :{" "}
                    </span>
                    {(Array.isArray(interviewKit && interviewKit?.topics) &&
                      interviewKit &&
                      interviewKit?.topics &&
                      interviewKit?.topics.length) ||
                      0}{" "}
                  </span>
                  <span className="mt-2 mr-4 font-weight-medium">
                    <span className="text-grey-4 font-weight-normal">
                      {" "}
                      Total Questions :{" "}
                    </span>

                    {countQuestions(interviewKit && interviewKit?.topics)}
                  </span>
                  <span className="mt-2 mr-4 font-weight-medium">
                    <span className="text-grey-4 font-weight-normal">
                      {" "}
                      Candidates Assigned :{" "}
                    </span>
                    {(Array.isArray(submittedCandidatesInterviewList) &&
                      submittedCandidatesInterviewList.length) ||
                      0}
                  </span>
                  <span className="mt-2 mr-4 font-weight-medium">
                    <span className="text-grey-4 font-weight-normal">
                      {" "}
                      Candidates Accepted :{" "}
                    </span>
                    {interviewKit?.accepted_interview_kits_count || 0}{" "}
                  </span>
                  <span className="mt-2 font-weight-medium">
                    <span className="text-grey-4 font-weight-normal">
                      {" "}
                      Candidates Submitted :{" "}
                    </span>
                    {interviewKit?.submitted_interview_kits_count || 0}{" "}
                  </span>
                </div>
                {Array.isArray(interviewKit?.all_skills) &&
                interviewKit?.all_skills.length > 0 ? (
                  <div className="d-flex align-items-center flex-wrap fs-smallest mb-2 mt-3">
                    <p className="mb-0 mr-2 text-capitalize">
                      {interviewKit?.all_skills.map((skill, index) => (
                        <span
                          key={index}
                          className="skill bg-grey px-2 rounded-sm mr-2 my-1 py-1 mb-2"
                        >
                          {skill?.skill}
                        </span>
                      ))}
                    </p>
                  </div>
                ) : null}
                <div className="d-flex justify-content-between mt-3">
                  <p className="text-grey-4 font-weight-normal">
                    Created on {dateFormatter(interviewKit?.created)}
                  </p>
                  <a
                    href="/create-assessment"
                    className="text-primary ml-3 font-weight-medium"
                  >
                    Create Assessment Kit
                  </a>
                </div>
              </div>
            </Container>
          </div>
        </>
      )}
      <div className="kanban-board-main mt-4">
        <div className="container">
          {/* <div className="d-flex justify-content-end mb-2">
            <button
              className="btn btn-light d-flex align-items-center"
              onClick={() => handleCloseBucketModal(!bucketListModal)}
            >
              <img
                src="/assets/images/add-bucket-icon.svg"
                alt="add-to-bucket"
                className="mr-2"
              />
              Bucket List
            </button>
          </div> */}
          <Tabs
            defaultActiveKey="AssignedCandidates"
            onSelect={() => ontabSelection()}
            className="mb-2"
          >
            <Tab
              eventKey="AssignedCandidates"
              title={`Assigned (${submittedCandidatesInterviewList.length})`}
            >
              {assignedloading ? (
                <div className="d-flex align-items-center justify-content-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <AssignedCandidates
                  onClickShortlist={onClickShortlist}
                  onClickUnShortlist={onClickUnShortlist}
                  nextPage={nextPage}
                  onNextPageClick={onNextPageClick}
                  submittedCandidatesInterviewList={
                    submittedCandidatesInterviewList
                  }
                  onViewAssessmentClick={onViewAssessmentClick}
                  onPublicProfileClick={onPublicProfileClick}
                  onShareAssessmentClick={onShareAssessmentClick}
                  shortlistIdLoading={shortlistIdLoading}
                  remark={remark}
                />
              )}
            </Tab>
            <Tab eventKey="SuggestedCandidates" title="Suggested">
              <SuggestedCandidates
                interviewKitSkills={interviewKitSkills}
                interviewKit={interviewKit}
                nextPage={nextPage}
                onNextPageClick={onNextPageClick}
                shortlistIdLoading={shortlistIdLoading}
                onClickUnShortlist={onClickUnShortlist}
                onClickShortlist={onClickShortlist}
              />
            </Tab>

            <Tab
              eventKey="ShortlistedCandidates"
              title={`ShortListed (${shortlistCandidates.length})`}
            >
              <ShortlistedCandidates
                onClickUnShortlist={onClickUnShortlist}
                nextPage={nextPage}
                onNextPageClick={onNextPageClick}
                shortlistCandidates={shortlistCandidates}
                onViewAssessmentClick={onViewAssessmentClick}
                onPublicProfileClick={onPublicProfileClick}
                onShareAssessmentClick={onShareAssessmentClick}
                remark={remark}
                shortlistIdLoading={shortlistIdLoading}
              />
            </Tab>
          </Tabs>
        </div>
      </div>

      <Modal
        size="md"
        show={bucketListModal}
        onHide={() => handleCloseBucketModal(!bucketListModal)}
        className=""
      >
        <Modal.Header className="bg-primary text-white">
          <Modal.Title className="text-uppercase">
            <h3 className="mb-0 text-white">Select Assessment Kit</h3>
          </Modal.Title>

          <FontAwesomeIcon
            icon={faXmark}
            className="fa-2x cursor-pointer"
            onClick={() => handleCloseBucketModal(!bucketListModal)}
          />
        </Modal.Header>
        <Modal.Body className="p-4">
          {isBucketListLoading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <>
              {Array.isArray(allBucketList) &&
                allBucketList.map((item) => (
                  <div className="d-flex mb-3 justify-content-between">
                    <span className="text-capitalize">{item?.title}</span>
                    <button
                      className="btn btn-primary"
                      disabled={checkExitingAssessment(item)}
                      onClick={() => onClickAddAssementToBucket(item?.id)}
                    >
                      {isAddToBucketLoading && addToBucketItem === item?.id ? (
                        <Loader />
                      ) : checkExitingAssessment(item) ? (
                        "Added"
                      ) : (
                        "Add "
                      )}
                    </button>
                  </div>
                ))}
            </>
          )}
        </Modal.Body>
      </Modal>
    </MainLayout>
  );
};
